import React, { PureComponent } from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import ReviewStepRow from "../ReviewStepRow";
import t from "@zendesk/client-i18n-tools";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import styles from "./styles.css";
import FilterList from "components/FilterList";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      filters {
        id
      }
      ruleName
      frequency
      notificationRecipient
    }
  }
`;

class ReviewStep extends PureComponent {
  render() {
    return (
      <Query query={dirtyStateQuery}>
        {({ data: { dirtyState } }) => {
          return (
            <React.Fragment>
              <p className={styles.title}>
                {t("knowledge-verification.review.title")}
              </p>
              <Gap.Large vertical />
              <div className={styles.details}>
                <ReviewStepRow
                  label={t("knowledge-verification.ruleName")}
                  value={dirtyState.ruleName}
                />
                <ReviewStepRow
                  label={t("knowledge-verification.step.frequency")}
                  value={t(
                    `knowledge-verification.frequency.${dirtyState.frequency}`
                  )}
                />
                {dirtyState.filters.length > 0 && (
                  <ReviewStepRow
                    label={t("knowledge-verification.review.filter-tags")}
                    value={<FilterList />}
                  />
                )}
                <ReviewStepRow
                  label={t("knowledge-verification.notifications.label")}
                  value={`${t(
                    `knowledge-verification.notifications.recipient.${
                      dirtyState.notificationRecipient
                    }`
                  )}`}
                />
              </div>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}
export default ReviewStep;



// WEBPACK FOOTER //
// ./src/components/ReviewStep/index.js